"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpProvider = exports.getHttpProviderConfig = exports.initHttpProvider = void 0;
const HttpService_1 = require("./HttpService");
let config = null;
const initHttpProvider = (providerConfig) => {
    config = providerConfig;
};
exports.initHttpProvider = initHttpProvider;
/** Returns the configured API/web base URLs (needed for full-page OIDC redirects). */
const getHttpProviderConfig = () => {
    if (!config) {
        throw new Error("HttpProvider not initialized. Call initHttpProvider() first.");
    }
    return config;
};
exports.getHttpProviderConfig = getHttpProviderConfig;
exports.httpProvider = new Proxy({}, {
    get(_, prop) {
        if (!config) {
            throw new Error("HttpProvider not initialized. Call initHttpProvider() first.");
        }
        const instance = HttpService_1.HttpService.getInstance(config);
        return instance[prop];
    },
});
//# sourceMappingURL=HttpProvider.js.map